<script>
import formatDate from '@utils/format-date-full'
import MixOptions from '@components/mix/mix-options'
import GenrePills from '@components/genre/genre-pills'

export default {
    components: { MixOptions, GenrePills },
    props: {
        mix: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        airDate() {
            if (this.mix.episode) {
                const date = new Date(this.mix.episode.air_start)
                return formatDate(date)
            }
            return ''
        },
    },
}
</script>

<template>
    <div
        v-if="mix"
        class="details"
    >
        <div class="details-inner">
            <BaseResourceCover
                :image-resource="mix.episode"
                :media-resource="mix"
                class="image"
                media-type="mix"
            >
                <div slot="secondaryActions">
                    <MixOptions :mix="mix" />
                </div>
            </BaseResourceCover>
            <h4 class="title">
                <BaseLink
                    v-if="mix && mix.artist"
                    :to="{ path: `/artist/${mix.artist.url}/${mix.artist.id}` }"
                >
                    <span class="title-inner">{{ mix.artist.title }}</span>
                </BaseLink>
                <BasePlaceholder
                    v-else
                    :size="13"
                />
            </h4>
            <h5 class="artist-title">
                <BaseLink
                    v-if="mix && mix.show"
                    :to="{ path: `/shows/${mix.show.id}` }"
                >
                    {{ mix.show.title }}
                </BaseLink>
                <BasePlaceholder
                    v-else
                    :size="11"
                />
            </h5>
            <p
                v-if="mix.description"
                class="description"
            >{{ mix.description }}</p>
            <GenrePills
                class="genres"
                :genres="mix.genre"
            />
            <div class="button">
                <BaseButtonPlay
                    :icon="true"
                    class="button-inner"
                    :resource="mix"
                />
            </div>
            <div class="actions">
                <BaseFavourites
                    :mix="mix"
                    button-type="tag"
                />
            </div>
            <div class="release-date">
                <div v-if="mix && airDate">Released {{ airDate }}</div>
                <BasePlaceholder
                    v-else
                    :size="14"
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.details {
    text-align: center;
    &-inner {
        margin-bottom: $s-xl;

        @include widescreen {
            position: sticky;
            top: $s-xl + $s-xxxl;
            margin-bottom: 0;
        }
    }
}

.title {
    margin-top: $s-l;
    margin-bottom: 0;

    &-inner {
        color: $c-white;
    }
}

.artist-title {
    margin-top: 0;
    margin-bottom: $s-s;
    font-size: 20px;
    color: $c-text-faded;
}

.description {
    @extend %contentTinyHeading;

    margin-top: 0;
    margin-bottom: $s-l;
    text-align: center;
}

.actions {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: $s-l;
}

.separator {
    position: relative;
    display: block;
    width: 100%;
    height: 1px;
    background: $c-mine-shaft;
}

.release-date {
    @extend %contentTinyHeading;
}

.genres {
    justify-content: center;
    margin-bottom: $s-l;
}
</style>
